import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import Modal from "react-modal";
import HelmetWrapper from "../../HelmetWrapper";
import MealsStructure from "../../components/diet/meal/MealsStructure";
import SearchNButtons from "../../components/common-components/SearchNButtons";
import AddFollowupStatus from "../../components/lead-management/followup-system/AddFollowupStatus";
import { selectAuth } from "../../components/auth/auth.selector";
import { fetchFollowupStatusData } from "../../redux/reducers/apiSlice";
import ReactVortoxSpinner from "../../components/common-components/ReactVortoxSpinner";
import PaymentLinkTable from "../../components/payment-link-system/PaymentLinkTable";
// import Loader from "../../components/ui/Loader";
import { formattedLongDate } from "../../components/common-data/Converts";
import { CheckCircleIcon, CrossCircleIcon } from "../../images/icons/icons";

const FollowupStatuses = () => {
  const dispatch = useDispatch();
  const authData = useSelector(selectAuth);
  const userInfoData = authData.user;
  const { followupStatusLoading, followupStatuses } = useSelector(
    (state) => state.api
  );
  // const { loading } = useSelector((state) => state.putApi);

  const iniModValues = {
    isModOpen: false,
    cardName: "",
    rowData: "",
  };
  const [modValues, setModValues] = useState(iniModValues);
  const [isPage, setIsPage] = useState(0);
  const iniAllFilters = {
    selCustomerIntent: "",
    selectedWhatsappVerification: "",
    isActive: "",
    searchString: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilters);
  const iniFilters = {
    limit: 10,
    page: isPage + 1,
    intent_id: allFilters.selCustomerIntent?.value || "",
    status: allFilters.isActive?.value || "",
    wap_verification: allFilters.selectedWhatsappVerification?.value || "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);
  const iniFollowupData = {
    allFollowups: [],
    pagination: [],
  };
  const [followupsData, setFollowupsData] = useState(iniFollowupData);

  const onCloseModal = () => {
    setModValues(iniModValues);
  };

  function getFollowupStatuses(filters) {
    dispatch(
      fetchFollowupStatusData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  const onClickSearch = () => {
    setIsPage(0);

    if (allFilters.searchString) {
      setSearchFilterApplied(true);
      setFilters((prevs) => ({ ...prevs, search: allFilters.searchString }));
    }
  };

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
    }));
  }, [isPage]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      intent_id: allFilters.selCustomerIntent?.value || "",
      status: allFilters.isActive?.value || "",
      wap_verification: allFilters.selectedWhatsappVerification?.value || "",
    }));
    setIsPage(0);
  }, [
    allFilters.selCustomerIntent,
    allFilters.isActive,
    allFilters.selectedWhatsappVerification,
  ]);

  useEffect(() => {
    getFollowupStatuses(filters);
  }, [filters]);

  useEffect(() => {
    if (followupStatuses?.status && followupStatuses?.data?.length > 0) {
      setFollowupsData((prevs) => ({
        ...prevs,
        allFollowups: followupStatuses.data,
        pagination: followupStatuses?.pagination || [],
      }));
    } else {
      setFollowupsData(iniFollowupData);
    }
  }, [followupStatuses]);

  useEffect(() => {
    if (allFilters.searchString?.length === 0) {
      setSearchFilterApplied(false);
      setFilters((prevs) => ({ ...prevs, search: "" }));
      setIsPage(0);
    }
  }, [allFilters.searchString]);

  const tbColumns = [
    {
      dataField: "display_label",
      text: "Display Name",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {row?.display_label?.replace(/_/g, " ") || "NA"}
          </span>
        );
      },
    },

    {
      dataField: "intent_name",
      text: "Customer Intent Category",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {row?.intent_name?.replace(/_/g, " ") || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "next_followup_required",
      text: "next followup required",
      formatter: (_, row) => {
        return (
          <span className="tb-data icon">
            {row?.next_followup_required ? (
              <CheckCircleIcon />
            ) : (
              <CrossCircleIcon />
            )}
          </span>
        );
      },
    },
    {
      dataField: "price_required",
      text: "plan info required",
      formatter: (_, row) => {
        return (
          <span className="tb-data icon">
            {row?.price_required ? <CheckCircleIcon /> : <CrossCircleIcon />}
          </span>
        );
      },
    },
    {
      dataField: "wap_verification",
      text: "Whatsapp Verification Required",
      formatter: (_, row) => {
        return (
          <span className="tb-data icon">
            {row?.wap_verification ? (
              <CheckCircleIcon />
            ) : (
              <CrossCircleIcon />
            )}
          </span>
        );
      },
    },
    // {
    //   dataField: "value",
    //   text: "Value",
    //   formatter: (_, row) => {
    //     return (
    //       <span className="tb-data" style={{ textTransform: "initial" }}>
    //         {row?.value || "NA"}
    //       </span>
    //     );
    //   },
    // },
    {
      dataField: "status",
      text: "Status",
      formatter: (_, row) => {
        return (
          <span
            className="tb-data withPadding borderRdius27"
            style={{
              background: row?.status === "active" ? "#E2EFD5" : "#F3DADA",
              color: row?.status === "active" ? "#379C00" : "#D90000",
            }}
          >
            {row?.status || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "date_added",
      text: "Date Added",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.date_added ? formattedLongDate(row.date_added) : "-"}
          </span>
        );
      },
    },
    {
      dataField: "action",
      text: "Action",
      formatter: (_, row) => (
        <div className="actionButtonContainer">
          <button
            className="actionBtn icon edit"
            onClick={() =>
              setModValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                rowData: row,
                cardName: "edit",
              }))
            }
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-pencil-fill"
              viewBox="0 0 16 16"
              style={{
                color:
                  row?.lead_status?.toLowerCase() === "closed" ||
                  row?.lead_status?.toLowerCase() === "converted"
                    ? "gray"
                    : "#CD0909",
              }}
            >
              <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.5.5 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11z" />
            </svg>
          </button>

          {/* <button
            className="actionBtn icon delete"
            disabled={true}
            style={{
              cursor: "not-allowed",
            }}
            onClick={(e) => {
              const payload = {
                uid: row?.lead_id,
              };
              // handleDelete(payload);
            }}
          >
            {loading ? (
              <Loader />
            ) : (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-trash3-fill"
                viewBox="0 0 16 16"
                style={{
                  color: "gray",
                }}
              >
                <path d="M11 1.5v1h3.5a.5.5 0 0 1 0 1h-.538l-.853 10.66A2 2 0 0 1 11.115 16h-6.23a2 2 0 0 1-1.994-1.84L2.038 3.5H1.5a.5.5 0 0 1 0-1H5v-1A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5m-5 0v1h4v-1a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5M4.5 5.029l.5 8.5a.5.5 0 1 0 .998-.06l-.5-8.5a.5.5 0 1 0-.998.06m6.53-.528a.5.5 0 0 0-.528.47l-.5 8.5a.5.5 0 0 0 .998.058l.5-8.5a.5.5 0 0 0-.47-.528M8 4.5a.5.5 0 0 0-.5.5v8.5a.5.5 0 0 0 1 0V5a.5.5 0 0 0-.5-.5" />
              </svg>
            )}
          </button> */}
        </div>
      ),
    },
  ];

  return (
    <HelmetWrapper title="WTF: Follow Up Management System">
      <Container className="bg-cloud-k px-50px" fluid>
        <Modal
          isOpen={modValues.isModOpen}
          onRequestClose={onCloseModal}
          contentLabel="Add Followup Status Modal"
          ariaHideApp={false}
        >
          <AddFollowupStatus
            userInfoData={userInfoData}
            closeModal={onCloseModal}
            callFunction={() => getFollowupStatuses(filters)}
            rowData={modValues.rowData}
            isEdit={modValues.cardName === "edit"}
          />
        </Modal>

        <Row>
          <Col>
            <MealsStructure text={"Follow-up System"} />
          </Col>
        </Row>
        <Row>
          <Col>
            <SearchNButtons
              pageName={"followup"}
              btnText={"+ Add New Follow-up Status"}
              onClickAdd={() =>
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  cardName: "add",
                }))
              }
              filters={allFilters}
              setFilters={setAllFilters}
              onClickSearch={onClickSearch}
              searchFilterApplied={searchFilterApplied}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <div className="fullWidthFlexCenter overflowAuto separatedTable mt30">
              {followupStatusLoading ? (
                <ReactVortoxSpinner />
              ) : (
                <PaymentLinkTable
                  tableData={followupsData.allFollowups}
                  tableColumns={tbColumns}
                  tablePagination={followupsData.pagination}
                  isPage={isPage}
                  setIsPage={(value) => setIsPage(value)}
                />
              )}
            </div>
          </Col>
        </Row>
      </Container>
    </HelmetWrapper>
  );
};

export default FollowupStatuses;
